import { render, staticRenderFns } from "./customers-list.vue?vue&type=template&id=2e6c0984&"
import script from "./customers-list.vue.ts?vue&type=script&lang=ts&"
export * from "./customers-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports